import { atom, useAtom } from "jotai";

import { defaultMarket, marketList } from "#/config/markets";
import type { Market, UnderlyingSymbol } from "#/types/markets";

export const marketAtom = atom<Market>(defaultMarket);

export const setMarketByUnderlyingAtom = atom(
  null,
  (_, set, underlying: UnderlyingSymbol) => {
    const market =
      marketList.find((item) => item.underlying === underlying) ??
      defaultMarket;

    set(marketAtom, market);
  },
);

export const useMarket = () => {
  const [market, setMarket] = useAtom(marketAtom);
  const [, setMarketByUnderlying] = useAtom(setMarketByUnderlyingAtom);

  return {
    market,
    setMarket,
    setMarketByUnderlying,
  };
};
